import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { MetricRecord } from "../MetricRecord";

/**
 * Return every metric published to a single session.
 *
 * Backs the session-detail "Metrics" tab. Unlike `useQueryMetrics`, this is a
 * single (non-paginated) call into `v1/metrics/session/{sessionId}/` with an
 * optional `limit` query param.
 */
export function useMetricsBySession(
  sessionId: string | undefined,
  orgId: string | undefined,
  limit?: number,
) {
  const { metricsService } = useDomainServices();

  return useQuery<MetricRecord[], Error>({
    queryKey: ["metricsBySession", sessionId, orgId, limit],
    queryFn: ({ signal }) => {
      if (sessionId === undefined) {
        return Promise.reject(new Error("Invalid sessionId"));
      }
      return metricsService.listMetricsBySession(sessionId, {
        abortSignal: signal,
        orgId,
        limit,
      });
    },
    enabled: sessionId !== undefined && orgId !== undefined,
    staleTime: 60_000,
  });
}
